import { useState } from 'react';
import { Form, FormCheck } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { format } from "date-fns";
import { useNavigate } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import DELETE_POST_MUTATION from '../queries/DELETE_POST_MUTATION';
import POSTS_QUERY from '../queries/POSTS_QUERY';
import PUBLISH_POST_MUTATION from '../queries/PUBLISH_POST_MUTATION';
import apolloClient from '../../../utils/apolloClient';
import LoadingButton from '../../../common/LoadingButton';

const PostListItem = (props: any) => {
    const post = props.post;
    const navigate = useNavigate();
    const [published, setPublished]: [boolean, Function] = useState(!!post.published);
    const [publishing, setPublishing]: [boolean, Function] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [deletePost, { loading: deleteLoading }] = useMutation(DELETE_POST_MUTATION, {
        variables: {
            postId: post.id,
        },
        onCompleted: (res) => {
            const postToDelete = res.deletePost;
            setDeleting(false);
            const data = apolloClient.readQuery({ query: POSTS_QUERY });
            const posts = data.posts.filter((p: any) => p.id !== postToDelete.id);
            apolloClient.writeQuery({
                query: POSTS_QUERY,
                data: {
                    posts: [...posts],
                },
            });
        }
    });
    const [publishPost, { loading: publishLoading }] = useMutation(PUBLISH_POST_MUTATION, {
        variables: {
            postData: {
                id: post.id,
                published: !published,
            },
        },
        onCompleted: (res) => {
            setPublishing(false);
            setPublished(!published);
        },
        refetchQueries: [
            {
                query: POSTS_QUERY,
            }
        ]
    });

    const renderModal = () => {
        if (deleting) {
            return (<tr>
                <th>Delete Post?</th>
                <td colSpan={1000}>
                    You are deleting <strong>{post.title}</strong>
                    <LoadingButton
                        loading={deleteLoading}
                        variant="danger"
                        className="ms-2"
                        size="sm"
                        onClick={() => deletePost()}
                    >Delete</LoadingButton>
                </td>
            </tr>);
        }
        if (publishing) {
            if (published) {
                return (<tr>
                    <th>Hide Post?</th>
                    <td colSpan={1000}>
                        <LoadingButton
                            loading={publishLoading}
                            variant="warning"
                            className="ms-2"
                            size="sm"
                            onClick={() => publishPost()}
                        >Hide</LoadingButton>
                    </td>
                </tr>);
            } else {
                return (<tr>
                    <th>Publish Post?</th>
                    <td colSpan={1000}>
                        <LoadingButton
                            loading={publishLoading}
                            variant="primary"
                            className="ms-2"
                            size="sm"
                            onClick={() => publishPost()}
                        >Publish</LoadingButton>
                    </td>
                </tr>);
            }
        }
        return null;
    }
    const prettyDate = (datestamp: string) => {
        const d = new Date(datestamp);
        return format(d, "M/d/YYY h:mm a");
    }
    return (<>
        <tr>
            <th scope="row">{post.slug} </th>
            <td>{post.title}</td>
            <td><Form><FormCheck type="switch" id={`published-${post.id}`} checked={publishing ? !published : published} label="" aria-label="is published" onChange={() => { setPublishing(!publishing) }} /></Form></td>
            <td>{prettyDate(post.updatedAt)}</td>
            <td className="text-center"><FontAwesomeIcon color="#B41D15" style={{ cursor: "pointer" }} icon="trash-alt" onClick={() => setDeleting(!deleting)} /></td>
            <td className="text-center"><FontAwesomeIcon color="#868e96" style={{ cursor: "pointer" }} icon="eye" /></td>
            <td className="text-center"><FontAwesomeIcon color="#868e96" style={{ cursor: "pointer" }} icon="edit" onClick={() => navigate(`/admin/edit-post/${post.id}`)} /></td>
        </tr>
        {renderModal()}
    </>);
};

export default PostListItem;
